import { AppModule } from './ModuleManager';
import { SystemSound } from '@/lib/systemSound';

/**
 * 系统音效模块
 * 在用户首次交互时初始化音频系统
 */
export class SystemSoundModule implements AppModule {
  name = 'SystemSound';
  priority = 5; // 中等优先级

  private clickHandler: (() => void) | null = null;
  private touchHandler: (() => void) | null = null;
  private initialized = false;

  init(): void {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    // 创建首次交互处理器
    const handleFirstInteraction = async () => {
      if (this.initialized) return;
      this.initialized = true;

      try {
        await SystemSound.init();
        console.log('[SystemSoundModule] Audio initialized successfully');
      } catch (error) {
        console.error('[SystemSoundModule] Failed to initialize:', error);
      }

      // 移除监听器
      this.removeListeners();
    };

    // 保存处理器引用以便清理
    this.clickHandler = handleFirstInteraction;
    this.touchHandler = handleFirstInteraction;

    // 添加事件监听器
    document.addEventListener('click', this.clickHandler);
    document.addEventListener('touchstart', this.touchHandler);

    console.log('[SystemSoundModule] Initialized, waiting for user interaction...');
  }

  destroy(): void {
    this.removeListeners();
    console.log('[SystemSoundModule] Destroyed');
  }

  private removeListeners(): void {
    if (typeof document === 'undefined') return;

    if (this.clickHandler) {
      document.removeEventListener('click', this.clickHandler);
      this.clickHandler = null;
    }
    if (this.touchHandler) {
      document.removeEventListener('touchstart', this.touchHandler);
      this.touchHandler = null;
    }
  }
}
